<template>
  <div class="card pb-3">
    <h2 class="subtitle mb-2">Event Information</h2>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 box-flex">
        <div class="data-block">
          <span class="title-block">Name</span>
          <span class="content-block">{{ event.name || "-" }}</span>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 box-flex">
        <div class="data-block">
          <span class="title-block">Code</span>
          <span class="content-block">{{ event.code || "-" }}</span>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 box-flex">
        <div class="data-block">
          <span class="title-block">Reservations</span>
          <span class="content-block">{{ event.reservationsCount || 0 }}</span>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 box-flex">
        <div class="data-block">
          <span class="title-block">Start Date</span>
          <span class="content-block">{{
            formatEventDate(event.startDate)
          }}</span>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 box-flex">
        <div class="data-block">
          <span class="title-block">End Date</span>
          <span class="content-block">{{ formatEventDate(event.endDate) }}</span>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 box-flex">
        <div class="data-block">
          <span class="title-block">Time Zone</span>
          <span class="content-block">{{ event.timezone || "-" }}</span>
        </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 box-flex">
        <div class="data-block">
          <span class="title-block">Customer</span>
          <span class="content-block">{{
            getEventCustomerName(event.customer)
          }}</span>
        </div>
      </div>

      <div class="col-12 box-flex">
        <div class="data-block">
          <span class="title-block">Description</span>
          <span class="content-block">{{ event.description || "-" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  formatEventDate,
  getEventCustomerName
} from "../services/event-format.service";

export default {
  name: "EventView",
  props: {
    // Event as returned by the API, with populated customer.
    event: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatEventDate,
    getEventCustomerName
  }
};
</script>
